import React from "react";
import { EDUCATION, SKILLS } from "../constants";
import { Download } from "lucide-react";

const About: React.FC = () => {
  return (
    <div className="pt-32 pb-20 px-6 md:px-20 max-w-4xl mx-auto">
      <section className="mb-20">
        <h2 className="text-4xl md:text-6xl font-bold mb-8 text-white">
          Aung Kaung Sett
        </h2>

        <div className="space-y-6 text-slate-400 leading-relaxed text-lg">
          <p>
            I am a software engineer and system builder with a strong focus on
            backend architecture, security-aware design, and scalable web
            applications. I enjoy turning real-world problems into reliable
            systems that people can actually use.
          </p>

          <p>
            My experience spans full-stack development using React, Spring Boot,
            and Node.js, with hands-on work in authentication, verification
            systems, payment flows, and event-based QR and barcode validation. I
            care deeply about how systems behave under real constraints such as
            security, data integrity, and scale.
          </p>

          <p>
            Beyond coding, I actively explore system design and cloud deployment
            using AWS and Google Cloud. I believe strong engineers are built by
            understanding how software runs in the real world — from database
            modeling to production environments — not just by writing code.
          </p>
        </div>

        {/* <button className="mt-10 flex items-center gap-3 px-8 py-3 bg-white text-black font-semibold rounded-full hover:bg-cyan-400 transition-all hover:scale-105">
          <Download size={18} />
          Download Resume (PDF)
        </button> */}
      </section>

      <section className="mb-20">
        <h3 className="text-sm uppercase tracking-[0.3em] text-cyan-500 font-bold mb-10">
          Education
        </h3>
        {EDUCATION.map((edu, idx) => (
          <div
            key={idx}
            className="border-l border-slate-800 pl-8 space-y-2 mb-8"
          >
            <h4 className="text-xl font-semibold text-white">
              {edu.institution}
            </h4>
            <p className="text-cyan-400 text-sm">
              {edu.degree} — {edu.period}
            </p>
            <p className="text-slate-500 text-sm max-w-2xl">
              {edu.description}
            </p>
          </div>
        ))}
      </section>

      <section>
        <h3 className="text-sm uppercase tracking-[0.3em] text-cyan-500 font-bold mb-10">
          Skills & Focus
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {SKILLS.map((skill, idx) => (
            <div key={idx}>
              <h4 className="text-white font-medium mb-4">{skill.category}</h4>
              <ul className="space-y-2">
                {skill.items.map((item) => (
                  <li
                    key={item}
                    className="text-slate-500 text-sm flex items-center gap-2"
                  >
                    <span className="w-1 h-1 bg-cyan-500 rounded-full"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
